import ServicePageTemplate from "@/components/landing/ServicePageTemplate";
export default function RecambiosPage() { return <ServicePageTemplate slug="recambios" />; }
